export enum TableKey {
  CAPITALIZATION = 'pageSize.capitalization',
  APPROPRIATION_GROUP = 'pageSize.appropriationGroup',
  ALLOTMENT_REQUEST_PENDING = 'pageSize.arPending',
  ALLOTMENT_REQUEST_SUBMITTED = 'pageSize.arSubmitted',
  ALLOTMENT_REQUEST_TODO = 'pageSize.arTodo',
  ALLOTMENT_REQUEST_IN_PROGRESS = 'pageSize.arInProgress',
  ALLOTMENT_REQUEST_READY_BATCH = 'pageSize.arReadyBatch',
}
